import { render, staticRenderFns } from "./buttonList.vue?vue&type=template&id=42817640&scoped=true"
import script from "./buttonList.vue?vue&type=script&lang=js"
export * from "./buttonList.vue?vue&type=script&lang=js"
import style0 from "./buttonList.vue?vue&type=style&index=0&id=42817640&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42817640",
  null
  
)

export default component.exports